import React from "react";
import Layout from "./layouts/Layout";
import Dashboard from "../pages/dashboard/Dashboard";
import NewUserPage from "../pages/users/NewUserPage";
import Groups from "../pages/Groups/Groups";
import SingleUser from "../pages/singleUser/SingleUser";
import IncreaseGroupCredit from "../pages/increaseGroupCredit/IncreaseGroupCredit";
import Charge from "../pages/charge/Charge";
import IncreaseHistory from "../pages/IncreaseListPeyment/IncreaseHistory";
import Transactions from "../pages/TransActions/Transactions";
import UnifiedReports from "../pages/report/UnifiedReports";
import Support from "../pages/support/Support";
import NewSupport from "../pages/support/NewSupport";
import SupportDetail from "../pages/support/supportDetail/SupportDetail";
import UnifiedSettings from "../pages/settings/UnifiedSettings";
import Logout from "../pages/auth/Logout";
import Food from "../pages/food/Food";
import CateringDetail from "../pages/cateringDetail/CateringDetail";
import PayCateringInvoices from "../pages/cateringDetail/payCateringInvoices/PayCateringInvoces";
import ProcessingInvoices from "../pages/cateringDetail/ProcessingInvoices/ProcessingInvoces";
import { NotFound } from "../pages/error/NotFound";

/**
 * One Layout for all authenticated pages so navigation does not remount
 * the shell (and the STOMP connection stays up).
 */
export const BrowserRouter = [
    {
        path: "",
        Component: () => {
            window.location = "/dashboard";
            return null;
        },
    },
    {
        Component: Layout,
        children: [
            { path: "dashboard", Component: Dashboard },

            { path: "personnel", Component: NewUserPage },
            { path: "personnel/list", Component: NewUserPage },
            { path: "personnel/groups", Component: Groups },
            { path: "personnel/detail/:PersonnelId", Component: SingleUser },

            { path: "allocations", Component: IncreaseGroupCredit },

            { path: "finance", Component: Charge },
            { path: "finance/wallet", Component: Charge },
            { path: "finance/IncreaseHistory", Component: IncreaseHistory },
            { path: "finance/transactions", Component: Transactions },

            { path: "reports", Component: UnifiedReports },
            { path: "reports/general", Component: UnifiedReports },
            { path: "reports/usage", Component: UnifiedReports },
            { path: "reports/finance", Component: UnifiedReports },

            { path: "support", Component: Support },
            { path: "support/tickets", Component: Support },
            { path: "support/newTicket", Component: NewSupport },
            { path: "support/detail/:supportId", Component: SupportDetail },
            { path: "support/new", Component: NewSupport },

            { path: "settings", Component: UnifiedSettings },
            { path: "settings/profile", Component: UnifiedSettings },
            { path: "settings/corporates", Component: UnifiedSettings },
            { path: "settings/details", Component: UnifiedSettings },
            { path: "settings/exit", Component: Logout },

            { path: "food", Component: Food },
            { path: "food/details/:cateringId", Component: CateringDetail },
            { path: "food/needToPay/:cateringId", Component: PayCateringInvoices },
            { path: "food/Process/:cateringId", Component: ProcessingInvoices },

            { path: "receipt", Component: Transactions },

            { path: "auth/logout", Component: Logout },

            { path: "*", Component: NotFound },
        ],
    },
];

export default BrowserRouter;
